import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";

const renderValue = (value) => {
  if (value == null) return "";
  const str = String(value).trim();
  if (!str || str === "—") return "";
  return str;
};

export default function ModalDetalhesEquipamento({ equipamento, onClose }) {
  if (!equipamento) return null;

  return (
    <Overlay state={true} changeState={onClose}>
      <Modal header close={onClose} size="md">
        <Formulario onSubmit={(e) => e.preventDefault()}>
          <FormComp
            title="ID"
            type="text"
            readOnly
            valor={renderValue(equipamento.id)}
          />
          <FormComp
            title="TIPO"
            type="text"
            readOnly
            valor={renderValue(equipamento.tipo)}
          />
          <FormComp
            title="EQUIPAMENTO"
            type="text"
            readOnly
            valor={renderValue(equipamento.descricao)}
          />
          <FormComp
            title="PATRIMÔNIO"
            type="text"
            readOnly
            valor={renderValue(equipamento.patrimonio)}
          />
          <FormComp
            title="Nº SÉRIE"
            type="text"
            readOnly
            valor={renderValue(equipamento.serial)}
          />
          <FormComp
            title="OBSERVAÇÕES"
            type="textarea"
            readOnly
            valor={renderValue(equipamento.observacoes)}
          />
          <FormComp
            title="MATRÍCULA DO RESPONSÁVEL"
            type="text"
            readOnly
            valor={renderValue(equipamento.responsavel)}
          />
          <FormComp
            title="NOME"
            type="text"
            readOnly
            valor={renderValue(equipamento.nome)}
          />
          <FormComp
            title="FUNÇÃO"
            type="text"
            readOnly
            valor={renderValue(equipamento.funcao)}
          />
          <FormComp
            title="CENTRO DE CUSTO"
            type="text"
            readOnly
            valor={renderValue(equipamento.centro_custo)}
          />
          <FormComp
            title="DATA DE INÍCIO"
            type="text"
            readOnly
            valor={renderValue(equipamento.data_inicio_label)}
          />
        </Formulario>
      </Modal>
    </Overlay>
  );
}
